(function() {
    'use strict';
    angular.module('wbPublic').controller('PageController', ['$scope', '$transitions', '$timeout', '$location', 'InviteService', function($scope, $transitions, $timeout, $location, InviteService) {

        $scope.hideLink = false;


    }]);
})();
